(function () {
  "use strict";

  /**
   * @module service
   */
  var service = {};

  /**
   * Initialise Service page
   *
   * @memberof module:service
   */
  service.init = function () {
    $(".qld__service_facility_toggle").on("click", function () {
      var listId = $(this).attr("aria-controls");
      if ($(this).attr("aria-expanded") == "false") {
        var html = $(this).html().replace("Show more", "Show less");
        $(this).attr("aria-expanded", "true").html(html);
        $("#" + listId).removeClass("qld__service_facility_cards--collapsed");
      } else {
        var html = $(this).html().replace("Show less", "Show more");
        $(this).attr("aria-expanded", "false").html(html);
        $("#" + listId).addClass("qld__service_facility_cards--collapsed");
      }
    });
  };

  QLD.service = service;

  document.addEventListener("DOMContentLoaded", QLD.service.init);
})();
